import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/segmento?${serialize(filtros)}`, { tela: 'segmento' })
}

export async function get (id) {
  return httpAuth.get(`/segmento/${id}`, { tela: 'segmento' })
}

export async function add (dados) {
  return httpAuth.post(`/segmento`, dados, { funcionalidade: 'segmento_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/segmento/${id}`, dados, { funcionalidade: 'segmento_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/segmento/${id}`, { funcionalidade: 'segmento_excluir' })
}
